/**
 * Single IANA timezone for scoreboard API (?timezone=) and day-bucketing (Intl formatToParts).
 * Prefer Intl; graceful UTC fallback keeps API + UI aligned in restricted runtimes.
 */
export function getResolvedScoreboardIanaTimeZone(): string {
  try {
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
      const rawTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (typeof rawTz === 'string' && rawTz.trim() !== '') {
        return rawTz.trim();
      }
    }
  } catch (error) {
    // Failsafe for restricted environments or older Android WebViews
    console.warn('Failed to resolve Intl timezone, falling back to UTC', error);
  }
  return 'UTC';
}
